export class UploadFiles {
    idProtocolo: string;
    documento: string;
    status: string;
    mensagem: string;
}